import type { PermissionCheck } from '@/lib/auth/permissions'
import { PROJECT_INSTALL_PERM, PROJECT_REPORT_PERM, PROJECT_WRITE_PERM } from './permissions'

export const DETAIL_TABS = ['overview', 'tasks', 'sprints', 'kanban', 'list', 'calendar', 'installations', 'files', 'notes', 'reports', 'settings'] as const
export type DetailTab = (typeof DETAIL_TABS)[number]
export const DETAIL_TAB_PERMS: Partial<Record<DetailTab, PermissionCheck>> = { installations: PROJECT_INSTALL_PERM, reports: PROJECT_REPORT_PERM, settings: PROJECT_WRITE_PERM }
